export default "__VITE_ASSET__D_77LazM__"